import { ValidHeimspielLivetickerProps } from './types'

const isValidHeimspielLivetickerProps = (
  props: any
): props is ValidHeimspielLivetickerProps => !!props?.matchId

export { isValidHeimspielLivetickerProps }
